<template>
  <div>
    <a-modal
      visible
      title="门店审核"
      :confirmLoading="confirmLoading"
      @ok="confirm"
      @cancel="$emit('complete', 'cancel')"
      closable
    >
      <a-form-model hideRequiredMark ref="ruleForm" :model="data" :rules="rules">
        <a-form-model-item required prop="status" label="审核结果">
          <a-radio-group v-model="data.status">
            <a-radio value="pass">通过</a-radio>
            <a-radio value="unpass">未通过</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item
          v-if="data.status === 'unpass'"
          required
          prop="cause"
          label="拒绝原因"
        >
          <a-textarea
            v-model="data.cause"
            :auto-size="{ minRows: 3, maxRows: 7 }"
            placeholder="请输入"
          ></a-textarea>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
export default {
  data () {
    return {
      confirmLoading: false,
      valid: false,
      data: {
        status: '',
        cause: ''
      },
      rules: {
        status: [{ required: true, message: '不可为空', trigger: 'change' }],
        cause: [{ required: true, message: '不可为空', trigger: 'change' }]
      }
    }
  },
  methods: {
    async confirm () {
      this.confirmLoading = true
      this.$refs.ruleForm.validate(valid => {
        this.valid = valid
      })
      if (!this.valid) {
        this.confirmLoading = false
        return
      }
      try {
        if (this.data.status === 'pass') {
          // 通过审核
          await this.$tkParse.post(`/store/reviewCreateStore`, {
            storeId: this.record.objectId
          })
          await this.$tkParse.put(`/classes/store/${this.record.objectId}`, {
            status: 'pass',
            auditTime: new Date().toISOString()
          })
          // 发送消息
          await this.$tkParse.post(`/classes/platformNotice`, {
            head: '您的门店审核已通过',
            type: 'store',
            agent: this.record.agent.objectId,
            className: 'store',
            readUsers: [],
            resourceId: this.record.objectId,
            associationType: 'storeAudit',
            permissionF: null,
            permissionS: null
          })
        } else {
          await this.$tkParse.put(`/classes/store/${this.record.objectId}`, {
            status: 'unpass',
            auditTime: new Date().toISOString(),
            cause: this.data.cause
          })
          // 发送消息
          await this.$tkParse.post(`/classes/platformNotice`, {
            head: '您的门店审核未通过',
            type: 'store',
            agent: this.record.agent.objectId,
            className: 'store',
            readUsers: [],
            resourceId: this.record.objectId,
            associationType: 'storeAudit',
            permissionF: null,
            permissionS: null
          })
        }
        this.$notification['success']({
          message: '操作成功',
          description: '审核成功'
        })
        this.confirmLoading = false
        this.$emit('complete', 'cancel')
        if (this.vm) {
          this.vm.refresh()
        } else {
          this.$emit('refresh')
        }
      } catch (e) {
        this.confirmLoading = false
        this.$notification['error']({
          message: '操作失败',
          description: '网络错误，请稍后重试'
        })
      }
      this.$emit('complete', 'cancel')
    }
  },
  props: {
    record: Object, // 当前行的数据
    vm: Object, // 触发这个action的组件对象，通常为modelTable或modelTree
    fields: Array, // 当前model的fields对象
    model: Object, // 当前model对象
    className: String, // 当前model的className
    modelName: String, // 当前model的名称
    category: String // 假如当前model显示为category格式，则会将当前的值传入
  }
}
</script>
<style>

</style>
